<template>
  <v-row class="custom-grey-border" :class="{ 'ml-0': !vShowCalendar }">
    <v-col
      md="12"
      class="light-gray-background custom-border-bottom d-flex justify-space-between"
    >
      <div
        style="font-size: 19px"
        class="text-uppercase font-weight-700 color-custom-blue"
      >
        Team ({{ assignedTeam?.length }})
      </div>

      <div>
        <v-menu
          v-if="false"
          bottom
          left
          offset-y
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              right
              small
              depressed
              v-bind="attrs"
              v-on="on"
            >
              <v-icon class="mr-2">mdi-account-group</v-icon>Assign
            </v-btn>
          </template>
          <v-list class="light-gray-background pb-0" min-width="340">
            <v-list-item-title
              class="text-uppercase font-weight-700 color-custom-blue font-size-16 p-2 pt-0"
            >
              Select Team
            </v-list-item-title>

            <perfect-scrollbar
              :options="{ suppressScrollX: true }"
              class="scroll custom-box-top-inner-shadow"
              style="max-height: 50vh; position: relative"
            >
              <v-list-item
                class="white-background"
                v-for="(team, index) in availableTeam"
                :key="index"
              >
                <v-checkbox
                  :input-value="assignedTeam"
                  :placeholder="team.engineer_display_name"
                  :value="team.engineer_id"
                  hide-details
                  color="cyan"
                  class="mr-4 mt-0"
                  v-on:change="updateScheduleState('dbAssignedTeam', $event)"
                  multiple
                >
                  <template v-slot:label>
                    <v-list-item>
                      <v-list-item-avatar>
                        <v-img
                          :lazy-src="$defaultProfileImage"
                          :src="team.engineer_profile_logo"
                        />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          class="font-size-16 font-weight-500"
                          v-html="team.engineer_display_name"
                        />
                        <v-list-item-subtitle
                          class="font-size-16 font-weight-500"
                          v-if="team.engineer_designation"
                          v-html="team.engineer_designation"
                        />
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-checkbox>
              </v-list-item>
            </perfect-scrollbar>
          </v-list>
        </v-menu>
        <v-btn
          
          color="cyan"
          class="mx-2 custom-bold-button white--text"
          :loading="jobLoading"
          :disabled="jobLoading"
          @click="getEngineers()"
          depressed
          right
          small
        >
          <v-icon style="font-size: 25px !important;"  small>mdi-refresh</v-icon>
        
        </v-btn>

        <v-btn
          v-if="availableTeam.length"
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          right
          small
          depressed
          @click="show_engineers = true"
        >
          <v-icon class="mr-2">mdi-account-group</v-icon>Assign
        </v-btn>
        <v-btn
          v-else
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          right
          small
          v-on:click="getEngineers()"
          depressed
          :disabled="jobLoading"
        >
          <v-icon class="mr-2">mdi-account-group</v-icon>Get Available
        </v-btn>
      </div>
    </v-col>
    <v-col md="12">
      <v-row>
        <v-col v-if="assignedTeamObject.length > 0" md="12" class="pa-0">
          <v-list-item
            v-for="(row, index) in assignedTeamObject"
            :key="index"
            class="border-bottom rounded px-2 mb-2 grey lighten-4"
          >
            <v-list-item-avatar class="my-1">
              <v-img
                :lazy-src="$defaultProfileImage"
                :src="row.engineer_profile_logo"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-size-14 font-weight-500">
                {{ row.engineer_display_name }}
                <template v-if="row.mark_as_tl">
                  <v-chip label small color="blue" outlined class="ml-2">
                    Team Lead
                  </v-chip>
                </template>
              </v-list-item-title>
              <v-list-item-subtitle
                class="font-size-12 font-weight-500"
                v-if="row.engineer_designation"
              >
                <v-chip
                  label
                  color="red"
                  small
                  outlined
                  style="font-size: 10px"
                >
                  {{ row?.engineer_designation }}
                </v-chip>
                <v-chip
                  v-if="row.is_manager == 1"
                  label
                  color="black"
                  small
                  outlined
                  class="ml-2"
                  style="font-size: 10px"
                >
                  Project Manager
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon class="my-1" link>
              <v-btn
                v-on:click="removeEngineer(row.engineer_id)"
                icon
                color="red lighten-1"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-list-item-icon>
          </v-list-item>
        </v-col>
        <v-col v-else md="12">
          <p class="font-size-16">No users are currently assigned</p>
        </v-col>
      </v-row>
    </v-col>
    <Dialog :common-dialog="show_engineers" :dialog-width="1450">
      <template v-slot:title>Team ({{ assignedTeam?.length }}) </template>
      <template v-slot:body>
        <v-container fluid class="py-0">
          <v-row>
            <v-col md="12" class="pt-0 custom-listing-table">
              <div class="d-flex">
                <v-text-field
                  style="max-width: 300px"
                  v-model.trim="search"
                  v-on:click:clear="(search = null), filterData()"
                  clearable
                  dense
                  filled
                  flat
                  placeholder="Search"
                  hide-details
                  solo
                  color="cyan"
                  class="mr-2"
                  @keydown.enter="filterData()"
                  @keydown.tab="filterData()"
                ></v-text-field>
                <v-autocomplete
                  hide-details
                  v-model.trim="type"
                  class="mr-2"
                  :items="typeList"
                  dense
                  flat
                  filled
                  style="max-width: 250px"
                  placeholder="Type"
                  item-color="cyan"
                  color="cyan"
                  solo
                  @change="getRelatedSkill()"
                  item-value="value"
                  item-text="text"
                >
                </v-autocomplete>
                <v-autocomplete
                  hide-details
                  v-model.trim="related_text"
                  class="mr-2"
                  :items="skillList"
                  dense
                  flat
                  filled
                  style="max-width: 250px"
                  placeholder="Type"
                  item-color="cyan"
                  color="cyan"
                  solo
                  clearable
                  v-on:click:clear="(related_text = null), filterData()"
                  @change="filterData()"
                  item-value="text"
                  item-text="text"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title
                        v-html="'No Category(s) Found.'"
                      ></v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-list-item-action class="ma-0">
                      <v-chip
                        style="height: 16px; width: 16px; padding: 0"
                        :color="item.color"
                      >
                      </v-chip>
                    </v-list-item-action>
                    <v-list-item-content class="py-0">
                      <v-list-item-title
                        class="text-capitalize font-weight-500 font-size-16"
                      >
                        <template v-if="item.value == 'all'"
                          >{{ item.text }}
                        </template>
                        <template v-else>{{ item.text }} </template>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-action class="mr-0">
                      <v-chip
                        style="height: 16px; width: 16px; padding: 0"
                        :color="item.color"
                      >
                      </v-chip>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title
                        class="text-capitalize font-weight-500 font-size-16"
                        >{{ item.text }}</v-list-item-title
                      >
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </div>
            </v-col>
            <v-col md="12" class="pt-0 custom-listing-table">
              <v-simple-table class="inner-simple-table" fixed-header>
                <template v-slot:default>
                  <thead
                    style="
                      background-color: rgb(243, 246, 249);
                      color: rgb(36, 50, 109);
                    "
                  >
                    <tr class="custom-border-bottom">
                      <td
                        class="font-size-16 font-weight-700 p-0"
                        style="width: 50px"
                      ></td>
                      <td
                        class="font-size-16 font-weight-700 p-0"
                        style="width: 260px"
                      >
                        Name
                      </td>
                      <td
                        class="font-size-16 font-weight-700 p-0"
                        style="width: 180px"
                      >
                        Visit/Leave Details
                      </td>
                      <td
                        class="font-size-16 font-weight-700 p-0"
                        style="width: 100px"
                      >
                        Mark As TL
                      </td>
                      <td
                        class="font-size-16 font-weight-700 p-0"
                        style="width: 140px"
                      >
                        Role
                      </td>
                      <td
                        class="font-size-16 font-weight-700 p-0"
                        style="width: 230px"
                      >
                        Skill
                      </td>
                      <td
                        class="font-size-16 font-weight-700 p-0"
                        style="width: 230px"
                      >
                        Certificates
                      </td>
                      <td
                        class="font-size-16 font-weight-700 p-0"
                        style="width: 230px"
                      >
                        Licenses
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="lodash.isEmpty(availableTeam) === false">
                      <tr
                        v-for="(row, index) in availableTeam"
                        :key="index"
                        :class="{ 'orange_lighten-5': index % 2 == 0 }"
                      >
                        <td class="p-0">
                          <v-checkbox
                            v-model="localAssignedTeam"
                            :value="row.engineer_id"
                            :disabled="
                              row?.engineer_disabled == 1 &&
                              visitType != 'recurring'
                                ? true
                                : false
                            "
                            hide-details
                            color="cyan"
                            class="mr-4 mt-0"
                          ></v-checkbox>
                        </td>

                        <td class="p-0">
                          <div class="d-flex">
                            <div class="mr-1">
                              <v-avatar size="35">
                                <v-img
                                  class="customer-image white-background"
                                  width="35"
                                  height="35"
                                  :lazy-src="$defaultProfileImage"
                                  :src="
                                    row.engineer_profile_logo
                                      ? row.engineer_profile_logo
                                      : $defaultProfileImage
                                  "
                                >
                                </v-img>
                              </v-avatar>
                            </div>
                            <div>
                              <span class="font-weight-700 text-capitalize">{{
                                row?.engineer_display_name
                              }}</span>
                              <span v-if="row?.engineer_disabled == 1">
                                <v-chip
                                  label
                                  small
                                  color="red"
                                  class="text-white ml-1"
                                  >Unavailable</v-chip
                                ></span
                              >
                              <div>
                                <v-chip
                                  label
                                  color="red"
                                  small
                                  outlined
                                  style="font-size: 10px"
                                >
                                  {{ row?.engineer_designation }}
                                </v-chip>
                              </div>
                            </div>
                          </div>
                        </td>

                        <td class="p-0">
                          <!-- If at least one visit -->
                          <template
                            v-if="
                              row.related_visits && row.related_visits.length
                            "
                          >
                            <!-- First Visit Barcode -->

                            <div>
                              <!-- Visit ID Label -->
                              <div style="margin-bottom: -3px">
                                <label class="mr-2">
                                  <v-icon small>mdi-pound</v-icon>
                                </label>
                                <v-chip
                                  class="mr-2 font-weight-600"
                                  color="chip-custom-blue"
                                  label
                                  small
                                  outlined
                                  @click="
                                    pushToVisit(row.related_visits[0].visit_id)
                                  "
                                >
                                  {{ row.related_visits[0].visit_barcode }}
                                </v-chip>
                              </div>

                              <!-- PIC Label -->
                              <div
                                class="mt-0 mb-0"
                                style="margin-bottom: -4px !important"
                                v-if="
                                  row.related_visits[0].pic_user_display_name
                                "
                              >
                                <label class="mr-4">
                                  <v-icon small>mdi-account</v-icon>
                                </label>

                                <span
                                  v-if="
                                    row.related_visits[0].pic_user_display_name
                                  "
                                >
                                  <b>{{
                                    row.related_visits[0].pic_user_display_name
                                  }}</b>
                                </span>

                                <em class="text-muted" v-else>
                                  No PIC Assigned
                                </em>
                              </div>

                              <v-chip
                                v-if="row.related_visits.length > 1"
                                small
                                color="blue white--text"
                                label
                                class="ml-1"
                                @click="openVisitPopup(row.related_visits)"
                              >
                                <span class="font-size-16 font-weight-500">
                                  +{{ row.related_visits.length - 1 }} More
                                </span>
                              </v-chip>
                            </div>
                            <!-- If More Visits -->
                          </template>

                          <em v-else>
                            <b>--</b>
                          </em>
                        </td>
                        <td class="p-0">
                          <!--   <v-checkbox
                            :disabled="checkDisabled(row.engineer_id)"
                            color="cyan"
                            hide-details
                            class="mt-0"
                            small
                            :value="row.mark_as_tl"
                            :input-value="row.mark_as_tl"
                            v-on:change="updateAssignedTeamObject(row, $event)"
                          ></v-checkbox> -->
                          <v-checkbox
                            :disabled="checkDisabledLocal(row.engineer_id)"
                            v-model="row.mark_as_tl"
                            hide-details
                            color="cyan"
                            class="mt-0"
                            @change="updateTeamLead(row)"
                          />
                        </td>
                        <td class="p-0">
                          <template v-if="row && row.engineer_role == 2">
                            <span class="font-weight-700">Technician</span>
                          </template>
                          <div>
                            <v-chip
                              v-if="row && row.is_manager == 1"
                              small
                              outlined
                              color="black"
                              label
                              class="mt-1"
                              text-color=""
                            >
                              Project Manager
                            </v-chip>
                          </div>
                        </td>
                        <td class="p-0">
                          <template v-if="row?.all_skills?.length">
                            <div class="text-list">
                              <template
                                v-for="(skill, index) in row.all_skills.slice(
                                  0,
                                  2
                                )"
                              >
                                <span
                                  :key="index"
                                  class="color-text"
                                  :style="{ color: skill.color || '#1976d2' }"
                                >
                                  {{ skill.certificate_name }}
                                </span>
                              </template>

                              <span
                                v-if="row.all_skills.length > 2"
                                class="more-text"
                              >
                                +{{ row.all_skills.length - 2 }} More
                              </span>
                            </div>
                          </template>

                          <em v-else><b>--</b></em>
                        </td>

                        <td class="p-0">
                          <template v-if="row?.all_certificates?.length">
                            <div class="text-list">
                              <template
                                v-for="(
                                  certificate, index
                                ) in row.all_certificates.slice(0, 2)"
                              >
                                <span
                                  :key="index"
                                  class="color-text"
                                  :style="{
                                    color: certificate.color || '#1976d2',
                                  }"
                                >
                                  {{ certificate.certificate_name }}
                                </span>
                              </template>

                              <span
                                v-if="row.all_certificates.length > 2"
                                class="more-text"
                              >
                                +{{ row.all_certificates.length - 2 }} More
                              </span>
                            </div>
                          </template>

                          <em v-else><b>--</b></em>
                        </td>
                        <td class="p-0">
                          <template v-if="row?.all_licenses?.length">
                            <div class="text-list">
                              <template
                                v-for="(
                                  license, index
                                ) in row.all_licenses.slice(0, 2)"
                              >
                                <span
                                  :key="index"
                                  class="color-text"
                                  :style="{ color: license.color || '#1976d2' }"
                                >
                                  {{ license.certificate_name }}
                                </span>
                              </template>

                              <span
                                v-if="row.all_licenses.length > 2"
                                class="more-text"
                              >
                                +{{ row.all_licenses.length - 2 }} More
                              </span>
                            </div>
                          </template>

                          <em v-else><b>--</b></em>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td :colspan="6">
                          <p
                            class="m-0 row-not-found text-center font-weight-500 font-size-16"
                          >
                            Sorry! No Team(s) Found.
                          </p>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="closeEngineer()"
        >
          Close
        </v-btn>
        <v-btn
          class="custom-bold-button ml-4"
          depressed
          @click="saveEngineers"
          color="cyan white--text"
          >Save</v-btn
        >
      </template>
    </Dialog>
    <v-row justify="center">
      <v-dialog
        origin="top center"
        v-model="dialogStatus"
        persistent
        content-class="warranty-dialog"
        :max-width="750"
      >
        <v-card>
          <v-card-title
            class="headline dialog-custom-header white-background custom-border-bottom custom-header-blue-text"
          >
            Visit Listing
          </v-card-title>
          <v-card-text class="p-8 font-size-16">
            <perfect-scrollbar
              :options="{ suppressScrollX: true }"
              class="scroll"
              style="max-height: 100vh; position: relative"
            >
              <v-row>
                <v-col md="12" style="margin-top: -20px !important">
                  <v-simple-table class="inner-simple-table" fixed-header>
                    <template v-slot:default>
                      <thead
                        style="
                          background-color: rgb(243, 246, 249);
                          color: rgb(36, 50, 109);
                        "
                      >
                        <tr class="custom-border-bottom">
                          <td class="font-size-16 font-weight-700 pt-2">
                            Visit #
                          </td>

                          <td class="font-size-16 font-weight-700 pt-2">
                            Visit PIC
                          </td>
                          <td class="font-size-16 font-weight-700 pt-2">
                            Started At
                          </td>
                          <td class="font-size-16 font-weight-700 pt-2">
                            Finished At
                          </td>
                          <td class="font-size-16 font-weight-700 pt-2">
                            Status
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="visitArr?.length > 0">
                          <tr
                            v-for="(data, index) in visitArr"
                            :key="index"
                            :class="{ 'orange_lighten-5': index % 2 == 0 }"
                          >
                            <td class="py-2 font-weight-500">
                              <v-chip
                                class="mr-2 font-weight-600"
                                color="chip-custom-blue"
                                label
                                small
                                outlined
                                @click="pushToVisit(data?.visit_id)"
                              >
                                {{ data?.visit_barcode }}
                              </v-chip>
                            </td>

                            <td class="py-2 font-weight-500">
                              <template v-if="data?.pic_user_display_name">
                                {{ data.pic_user_display_name }}
                              </template>
                              <em class="text-muted" v-else> no visit pic </em>
                            </td>

                            <td class="py-2">
                              <span
                                class="font-weight-500"
                                v-if="data?.started_at"
                              >
                                {{ formatDate(data.started_at) }}
                                {{ formatDateTimeStart(data.started_at) }}
                              </span>
                            </td>
                            <td class="py-2">
                              <span
                                class="font-weight-500"
                                v-if="data?.finished_at"
                              >
                                {{ formatDate(data.finished_at) }}
                                {{ formatDateTimeStart(data.finished_at) }}
                              </span>
                            </td>
                            <td class="py-2">
                              <v-chip
                                v-if="data.visit_status > 0"
                                class="custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
                                :color="getStatusColor(data.visit_status)"
                                label
                                small
                                :text-color="
                                  data.visit_status == 2 ? 'black' : 'white'
                                "
                              >
                                {{ getVisitStatusText(data) }}
                              </v-chip>
                            </td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr>
                            <td :colspan="6">
                              <p
                                class="m-0 row-not-found text-center font-weight-500 font-size-16"
                              >
                                Sorry! No visits(s) Found.
                              </p>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </perfect-scrollbar>
          </v-card-text>
          <v-divider class="my-0"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="warrant-manage-action">
              <v-btn
                depressed
                class="mx-2 custom-grey-border custom-bold-button"
                v-on:click="dialogStatus = false"
                >Close
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-row>
</template>

<style scoped>
.table-wrapper {
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
}

.inner-simple-table table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.inner-simple-table th {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #f3f6f9;
  white-space: nowrap; /* Prevent header from breaking into multiple lines */
}

.inner-simple-table th,
.inner-simple-table td {
  padding: 10px 8px;
  vertical-align: top;
  word-break: break-word;
}
.text-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.color-text {
  font-size: 12px;
  font-weight: 600;
  display: contents;
}

.more-text {
  color: #1976d2;
  font-size: 12px;
  font-weight: 600;
}
.action-btn {
  height: 38px !important;
  min-width: 120px;
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: .3px;
  text-transform: none !important;
}


</style>
<script>
import { mapGetters } from "vuex";
import { GET } from "@/core/services/store/request.module";
import {
  REMOVE_ENGINEER,
  GET_AVAILABLE_ENGINEER,
  UPDATE_SCHEDULE_STATE,
  UPDATE_SCHEDULE_ENGINEER,
} from "@/core/services/store/job.module";
import moment from "moment-timezone";
import Dialog from "@/view/pages/partials/Dialog.vue";
/* import { GET_TICKET } from "@/core/services/store/job.module"; */
import { find } from "lodash";
import CommonMixin from "@/core/plugins/common-mixin";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";

export default {
  name: "job-ctx-schedule-team",
  mixins: [CommonMixin],
  props: {
    visitType: {
      type: String,
      default: null,
    },
  },
  watch: {
    availableTeam: {
      handler(newValue) {
        newValue.forEach((row) => {
          const engineer = this.localAssignedTeamObject.find(
            (e) => e.engineer_id === row.engineer_id
          );

          if (engineer) {
            this.$set(row, "mark_as_tl", engineer.mark_as_tl);
          }
        });
      },
      deep: true,
      immediate: true,
    },
    localAssignedTeam: {
      handler(newValue) {
        // Reset Team Lead for unselected engineers
        this.localAssignedTeamObject.forEach((engineer) => {
          if (!newValue.includes(engineer.engineer_id)) {
            engineer.mark_as_tl = false;
          }
        });

        // Also reset in availableTeam (current search result)
        this.availableTeam.forEach((engineer) => {
          if (!newValue.includes(engineer.engineer_id)) {
            engineer.mark_as_tl = false;
          }
        });

        // Remove unchecked engineers
        this.localAssignedTeamObject = this.localAssignedTeamObject.filter(
          (e) => newValue.includes(e.engineer_id)
        );

        // Add newly selected engineers
        this.availableTeam.forEach((row) => {
          if (
            newValue.includes(row.engineer_id) &&
            !this.localAssignedTeamObject.some(
              (e) => e.engineer_id === row.engineer_id
            )
          ) {
            this.localAssignedTeamObject.push({ ...row });
          }
        });
      },
      deep: true,
    },
    show_engineers(val) {
      if (val) {
        this.localAssignedTeam = [...this.assignedTeam];

        this.localAssignedTeamObject = JSON.parse(
          JSON.stringify(this.assignedTeamObject)
        );

        // Reset TL for unassigned engineers
        this.localAssignedTeamObject.forEach((engineer) => {
          if (!this.localAssignedTeam?.includes(engineer.engineer_id)) {
            engineer.mark_as_tl = 0;
          }
        });

        // Also update availableTeam if you're showing TL checkbox there
        this.availableTeam.forEach((engineer) => {
          if (!this.localAssignedTeam?.includes(engineer.engineer_id)) {
            engineer.mark_as_tl = 0;
          }
        });
      }
    },
  },
  data() {
    return {
      localAssignedTeam: [],
      localAssignedTeamObject: [],
      show_engineers: false,
      visitId: 0,
      ticketId: 0,
      search: null,
      type: "all",
      related_text: null,
      skillList: [],
      visitArr: [],
      dialogStatus: false,
      typeList: [
        { value: "all", text: "All" },
        { value: "skill", text: "Skill" },
        { value: "certificate", text: "Certificate" },
        { value: "license", text: "Licences" },
      ],
    };
  },

  methods: {
    updateTeamLead(row) {
      const index = this.localAssignedTeamObject.findIndex(
        (e) => e.engineer_id === row.engineer_id
      );

      if (index !== -1) {
        this.$set(
          this.localAssignedTeamObject[index],
          "mark_as_tl",
          row.mark_as_tl
        );
      }
    },
    saveEngineers() {
      const selectedEngineers = [...this.localAssignedTeamObject];

      // Count selected TLs
      const totalTL = selectedEngineers.filter(
        (row) => row.mark_as_tl == 1 || row.mark_as_tl === true
      ).length;

      // Maximum TL allowed = half of selected technicians (rounded up)
      const maxTLAllowed = Math.ceil(selectedEngineers.length / 2);

      if (totalTL > maxTLAllowed) {
        ErrorEventBus.$emit(
          "update:error",
          InitializeError(
            `Maximum ${maxTLAllowed} Team Lead(s) allowed for ${selectedEngineers.length} selected technician(s).`
          )
        );

        return false;
      }

      this.$store.commit(UPDATE_SCHEDULE_STATE, {
        key: "dbAssignedTeam",
        value: [...this.localAssignedTeam],
      });

      this.$store.commit(UPDATE_SCHEDULE_STATE, {
        key: "dbAssignedTeamObject",
        value: selectedEngineers,
      });

      this.$store.commit(UPDATE_SCHEDULE_ENGINEER);
      this.show_engineers = false;
    },

    checkDisabledLocal(id) {
      return !this.localAssignedTeam?.includes(id);
    },
    getVisitStatusText(row) {
      switch (Number(row.visit_status)) {
        // 1 => Open
        case 1:
          return "Open";

        // 2 => In-Progress
        case 2:
          return "In-Progress";

        // 3 => Hold
        case 3:
          return row.is_leave_unssign == 1
            ? "Hold & Unassigned"
            : "Hold & Stay Assigned";

        // 4 => Completed
        case 4:
          return "Completed";

        // 5 => Cancelled
        case 5:
          return "Cancelled";

        // 6 => Hold (New Condition)
        case 6:
          return row.is_stay_assign == 0
            ? "Hold & Unassigned"
            : "Hold & Assigned";

        default:
          return "";
      }
    },
    pushToVisit(id) {
      const route = this.$router.resolve({
        name: "admin.visit.detail",
        params: { id },
      });
      window.open(route.href, "_blank");
    },

    formatDateTimeStart(row) {
      return moment(row).format("hh:mm A");
    },
    openVisitPopup(visits) {
      this.visitArr = visits;
      this.dialogStatus = true;
    },
    checkDisabled(id) {
      if (find(this.assignedTeam, (row) => row == id)) {
        return false;
      }
      return true;
    },
    closeEngineer() {
      this.show_engineers = false;
      /* if (this.visitId > 0) {
        let key = "dbAssignedTeam";
        let value = this.assignedTeam;
        let statekey = "dbAssignedTeamObject";
        let stateValue = this.assignedTeamObject;
       
        this.$store.commit(UPDATE_SCHEDULE_STATE, { key, value });
        this.$store.commit(UPDATE_SCHEDULE_STATE, { statekey, stateValue });
        this.$store.commit(UPDATE_SCHEDULE_ENGINEER);
        this.show_engineers = false;
      } else {
        let key = "dbAssignedTeam";
        let value = [];
        let statekey = "dbAssignedTeamObject";
        let stateValue = [];
        this.$store.commit(UPDATE_SCHEDULE_STATE, { key, value });
        this.$store.commit(UPDATE_SCHEDULE_STATE, { statekey, stateValue });
        this.$store.commit(UPDATE_SCHEDULE_ENGINEER);
        this.show_engineers = false;
      } */
    },
    updateScheduleState(key, value) {
      this.teamUpdate = true;
      this.$store.commit(UPDATE_SCHEDULE_STATE, { key, value });
      this.$store.commit(UPDATE_SCHEDULE_ENGINEER);
    },
    updateAssignedTeamObject(value, event) {
      let flagValue = false;
      if (event) {
        flagValue = true;
      }
      if (this.assignedTeamObject && this.assignedTeamObject.length > 0) {
        for (let i = this.assignedTeamObject?.length - 1; i >= 0; i--) {
          if (this.assignedTeamObject[i].engineer_id == value.engineer_id) {
            (this.assignedTeamObject[i].mark_as_tl = flagValue),
              (this.availableTeam[i].mark_as_tl = flagValue);
          } else {
            this.availableTeam[i].mark_as_tl = false;
            this.assignedTeamObject[i].mark_as_tl = false;
          }
        }
      }
      if (this.availableTeam && this.availableTeam.length > 0) {
        for (let i = this.availableTeam?.length - 1; i >= 0; i--) {
          if (this.availableTeam[i].engineer_id == value.engineer_id) {
            this.availableTeam[i].mark_as_tl = flagValue;
          } else {
            this.availableTeam[i].mark_as_tl = false;
          }
        }
      }
      let statekey = "dbAssignedTeamObject";
      this.$store.commit(UPDATE_SCHEDULE_STATE, { statekey, value });
    },

    removeEngineer(id) {
      this.$store.commit(REMOVE_ENGINEER, id);
    },
    filterData() {
      this.getEngineers();
      /* if (this.visitId > 0) {
        this.$store.dispatch(GET_TICKET, {
          ticket: this.ticketId,
          visit: this.visitId,
          search: this.search ? this.search : "",
          related_text: this.related_text ? this.related_text : "",
          type: this.type ? this.type : "",
        });
      } else {
        this.getEngineers();
      } */
    },
    getRelatedSkill() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: `related-skill/${this.type}`,
        })
        .then(({ data }) => {
          _this.skillList = data;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    getEngineers() {
      let payload = {
        search: this.search,
        related_text: this.related_text || "",
        type: this.type || "",
        force: this.visitId && this.visitId > 0 ? 1 : 0,
        visit: this.visitId > 0 ? this.visitId : 0,
      };

      if (this.visitType === "one-off") {
        payload = {
          ...payload,
          start_date: moment(this.oneOffSchedule.start_date).format(
            "YYYY-MM-DD"
          ),
          start_time: moment(
            `${this.oneOffSchedule.start_date} ${this.oneOffSchedule.start_time}`
          ).format("HH:mm"),
          end_date: moment(this.oneOffSchedule.end_date).format("YYYY-MM-DD"),
          end_time: moment(
            `${this.oneOffSchedule.end_date} ${this.oneOffSchedule.end_time}`
          ).format("HH:mm"),
        };
      }
      if (this.visitType === "recurring") {
        if (!this.scheduleOutput.length) {
          ErrorEventBus.$emit(
            "update:error",
            InitializeError("Please prepare the schedule first.")
          );
          return false;
        }
        payload = {
          ...payload,
          start_date: moment(this.scheduleOutput[0]?.startDate).format(
            "YYYY-MM-DD"
          ),
          start_time: moment(
            `${this.scheduleOutput[0]?.startDate} ${this.scheduleOutput[0]?.startTime}`
          ).format("HH:mm"),
          end_date: moment(this.scheduleOutput[0]?.endDate).format(
            "YYYY-MM-DD"
          ),
          end_time: moment(
            `${this.scheduleOutput[0]?.endDate} ${this.scheduleOutput[0]?.endTime}`
          ).format("HH:mm"),
        };
      }

      this.$store.dispatch(GET_AVAILABLE_ENGINEER, payload);
    },
  },

  computed: {
    ...mapGetters([
      "vShowCalendar",
      "oneOffSchedule",
      "recurringSchedule",
      "jobLoading",
      "availableTeam",
      "assignedTeam",
      "assignedTeamObject",
      "scheduleType",
      "scheduleOutput",
    ]),
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 60);
    },
  },
  components: {
    Dialog,
  },
  created() {
    this.visitId = Number(this.$route?.query?.visit ?? 0);
    this.ticketId = Number(this.$route?.query?.ticket ?? 0);
  },
  mounted() {
    this.getRelatedSkill();
  },
};
</script>
